var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats-container"},[_c('div',{staticClass:"stats-content-horizontal"},[_c('span',{staticClass:"stats-value"},[_vm._v(_vm._s(_vm.formattedDisplayValue))]),_c('span',{staticClass:"stats-title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }